import { FileUploadStatus } from '../enums';
export const retryFilesUploadReducer = (state, action) => {
    let byId = state.byId;
    const allIds = state.allIds;
    Array.from(action.payload.files).forEach(fileInfo => {
        const id = fileInfo.id;
        if (byId[id]) {
            byId = Object.assign(Object.assign({}, byId), { [id]: Object.assign(Object.assign({}, byId[id]), { uploadStatus: FileUploadStatus.READY }) });
        }
    });
    return { byId: byId, allIds: allIds };
};
//# sourceMappingURL=retryFilesUploadReducer.js.map